import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaUsers, FaChalkboardTeacher, FaHandshake } from 'react-icons/fa';
import './DigitalActivitiesSection.css';

const DigitalActivitiesSection = () => {
  return (
    <div className="digital-activities-section">
      <Container>
        <h2 className="activities-title" data-aos="fade-down">
          Enhancing School Presence Through Digital Activities
        </h2>
        <Row className="activities-content">
          <Col md={12} lg={4} className="activity-item" data-aos="fade-up" data-aos-delay="100">
            <div className="activity-text">
              <h4>Student as Brand Ambassadors</h4>
              <p>
                Developing student personalities to become proud school representatives and encouraging student-led content on social media for greater visibility and engagement.
              </p>
            </div>
            <div className="activity-icon neon">
              <FaUsers />
            </div>
          </Col>
          <Col md={12} lg={4} className="activity-item" data-aos="fade-up" data-aos-delay="300">
            <div className="activity-text">
              <h4>Academic Enrichment via Online Integration</h4>
              <p>
                Offering live online coaching for IIT-JEE & NEET prep, helping reduce reliance on tuitions and enhancing modern learning techniques with performance reviews and updates.
              </p>
            </div>
            <div className="activity-icon neon">
              <FaChalkboardTeacher />
            </div>
          </Col>
          <Col md={12} lg={4} className="activity-item" data-aos="fade-up" data-aos-delay="500">
            <div className="activity-text">
              <h4>Provision for Honorary Manager</h4>
              <p>
                Arranging an honorary manager to establish third-party connections, enhance PR, and help build a positive image of the school while generating extra revenue.
              </p>
            </div>
            <div className="activity-icon neon">
              <FaHandshake />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DigitalActivitiesSection;
